import { Component, OnInit } from '@angular/core';
import { VolunteerSubsriptionService } from '../../Services/volunteerSubscription.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../Services/auth.service';

import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { MemberService } from '../../Services/member.service';


@Component({
  selector: 'app-volunteer-subscription-list',
  template: require('./volunteer-subscription-list.component.html'),
  styles: [require('./volunteer-subscription-list.component.css')]
})
export class VolunteerSubscriptionListComponent implements OnInit {
  loading: boolean = false;  
  showSearched:boolean =false;
  activityId = 0
  subscriberList:any=[]

  members: any[] = [];
  nameSearchString: string = '';
  searched_members: any[] = [];
  selectedMemberId:number= -1;

  
  activity:any={
    id : -1,
    beginDate : "",
    endDate : "",
    subject : "",
    description : "",
    open : false,
    allowRemarks : false
  }

  volunteer:any={
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
    remarks: '',
    telephoneNr: '',
    isMember:false,
    memberId: -1,
    organizationalRemark:''
  }


  constructor(  
    private route: ActivatedRoute,
    private auth: AuthService, 
    private volunteerSubsriptionService: VolunteerSubsriptionService,
    private memberService: MemberService
   ) {
      route.params.subscribe(p => {
        if (p['id'])
          this.activityId = +p['id'];
        else
          this.activityId = 0;
      });
    }

  ngOnInit() {
    this.loadSubscribers()
    this.loadActivityById()
  }

  

  private loadAllMembers() {
    // console.log("loading all members");
    this.memberService.getSimpleMembers().subscribe(x => {
      this.members = x;
      // console.log(this.members);
      this.searched_members = this.members
    });
  }

  loadSubscribers(){
    this.volunteerSubsriptionService.getAllVolunteerSubscriptionsForActivity(this.activityId).subscribe( (res:any)=>{
      // console.log(res);      
      if (res.status == 200){
        this.subscriberList = res.value

      }     
    })
  }

  loadActivityById(){
    this.volunteerSubsriptionService.getVolunteerActivityById(this.activityId).subscribe( (res:any)=>{
      // console.log(res);
      if (res.status == 200){
        this.activity = res.value
        // console.log(this.activity);
        // if (this.activity.askGsm) this.amountOFColspan +=1;
        // if (this.activity.askTeam) this.amountOFColspan +=1;
        // if (this.activity.askBirthday) this.amountOFColspan +=1;
        // if (this.activity.extraQuestion) this.amountOFColspan +=1;
        // if (this.activity.askGender) this.amountOFColspan +=1;
        // if (this.activity.askAddress) this.amountOFColspan +=1;
        // if (this.activity.askNationality) this.amountOFColspan +=1;
      }
    } )
  }
  
  checkboxAddMemberChanged(){
    console.log("checkboxAddMemberChanged");
    this.loadAllMembers()

  }

  checkboxIsMemberClicked(id: number){
    var sub = this.subscriberList.find( (s:any)=> s.id == id )
    sub.isMember = !sub.isMember

    this.volunteerSubsriptionService.addVolunteerSub(sub).subscribe( (res:any)=>{
      console.log(res)
    })
  }

  clearInput(){
    this.volunteer={
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      remarks: '',
      telephoneNr: '',
      isMember: false,
      memberId: -1,
      organizationalRemark:''
    }
    this.showSearched = false;
    this.clearSearch();
  }

  MemberSelect(id:number){
    this.selectedMemberId = id;
    this.volunteer.memberId = id;

    var member = this.searched_members.find( x=> x.id === id)
    this.volunteer.firstName = member.firstName;
    this.volunteer.lastName = member.lastName;
    

  }

  getActiveClass(id:number){
     var s = 'list-group-item'
     if (id === this.selectedMemberId){
      s += ' active'
     }
     return s;
  }

  private checkIfValid(){

      // && this.volunteer.email.length > 0

      if (this.volunteer.isMember && this.volunteer.memberId > -1 && this.volunteer.firstName.length > 0 && this.volunteer.lastName.length > 0){
        return true
      }else if(!this.volunteer.isMember && this.volunteer.firstName.length > 0 && this.volunteer.lastName.length > 0 ){
        return true;
      }else{
        return false;
      }

  }

  SaveVolunteerSubscription(){   

    if (this.checkIfValid()){
      // console.log("is valid");
      var data = {
        "id": this.volunteer.id ,
        "firstName": this.volunteer.firstName,
        "lastName": this.volunteer.lastName,
        "email": this.volunteer.email,
        "remarks": this.volunteer.remarks,
        "telephoneNr": this.volunteer.telephoneNr,
        "volunteerActivityID": this.activity.id,
        "memberId": this.volunteer.memberId,
        "isMember": this.volunteer.isMember,
        "organizationalRemark": this.volunteer.organizationalRemark
      }
    
      this.volunteerSubsriptionService.addVolunteerSub(data).subscribe( (res:any) =>{
        // console.log(res);
        
        if (res.status == 200){
          this.loadSubscribers()
          this.clearInput()
        }
      })
    }
    
  }

  showMessage(s:string){
    Swal.fire({
      showCancelButton:false,
      cancelButtonText: "Annuleren",
      title: "Opmerking: ",
      type: "info",
      input: 'textarea',
      inputAttributes: {
        "readonly": "",
        "style": "color: darkgrey;background-color: lightgrey;"
      },
      inputValue: s

    })
  }

  editSub(id:number){
    var sub = this.subscriberList.find( (s:any)=> s.id == id )
    var bd = new Date(sub.birthday);
      
    this.volunteer = sub;
    (<any>$('#newVolunteerSubscriptionModal')).modal();
  }

  deleteSub(id: number){
    // console.log("delete sub with id:", id);
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze inschrijving wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.volunteerSubsriptionService.deleteSubsciptionFromActivity(id).subscribe( (res:any)=>{
          // console.log("Result of delete: ", res);
          this.loadSubscribers()
        })
      }
    });
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      let f = this.members.filter( (a:any)=> a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      let l = this.members.filter( (a:any) => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      if (f.length > 0) {
        this.searched_members = f
      }
      if (l.length > 0) {
        this.searched_members = this.searched_members.concat(l)
      }
      
      this.showSearched = true;
        
      }else{
        this.searched_members = this.members
        this.showSearched = false;
      }
  }

  clearSearch(){
    this.nameSearchString = '';
    this.showSearched = false;
    this.searchName();
  }

  copyEmailAdressesToClipBoard(){
    var addresses: string= "";
    this.subscriberList.forEach( (element:any)=>{
      var email = element.email
      if (email.length > 0){
        addresses += email+";"
      }          
    })
    
    this.copyMessage(addresses);
    Swal.fire({
      // title: '',
      text: "Alle email adressen gekopieerd naar het clipboard",
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
 

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/volunteer-subscription-list/volunteer-subscription-list.component.ts